import { Utils } from "./common";
// NOTE: This isn't currently working
export const setWebpackPublicPath = () => {
  window.__webpack_public_path__ = Utils.obtainAssetLocationOverride() || Utils.determineCurrentScriptPrefix();
};